import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Slide,
  TextField,
} from "@mui/material";

import React, { useState } from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import Utils from "../utils";
import Constants from "../data/Constants";
import * as yup from "yup";
import { useFormik } from "formik";
import Lottie from "react-lottie-player";
import uploadLottie from "data/lotties/upload.json";

// https://dev.to/rajeshroyal/video-thumbnails-generate-with-vanilla-js-reactjs-like-youtube-3ok8
import {
  getVideoCover,
  getVideoDurationFromVideoFile,
} from "@rajesh896/video-thumbnails-generator";

// https://www.npmjs.com/package/@cyntler/react-doc-viewer
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { createMedia } from "services/media.service";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function MediaUploadDialog(props) {
  const { onCreate, onClose, open, onError } = props;

  const [status, setStatus] = useState({
    loading: false,
    error: false,
    success: false,
  });

  const defaultMedia = {
    name: "",
    type: "",
    file: null,
    duration: undefined,
    thumbnail: undefined,
    context: undefined,
  };

  const validationSchema = yup.object({});

  const formik = useFormik({
    initialValues: defaultMedia,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      formSubmitHandler(values);
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  const handleUpload = async (e) => {
    formik.setFieldValue("name", e.target.files[0].name ?? "Unnamed File");
    console.log(e.target.files[0]);

    const type = Utils.detectMediaType(e.target.files[0]);
    formik.setFieldValue("type", type);
    formik.setFieldValue("file", e.target.files[0]);
    formik.setFieldValue("fileUri", URL.createObjectURL(e.target.files[0]));

    if (type == "VIDEO") {
      const duration =
        Math.floor(
          ((await getVideoDurationFromVideoFile(e.target.files[0])) / 60) * 100
        ) / 100;

      formik.setFieldValue("duration", duration);

      formik.setFieldValue(
        "thumbnail",
        await getVideoCover(
          URL.createObjectURL(e.target.files[0]),
          duration / 2
        )
      );
    }

    // try {
    //   setProgress(true);

    //   forceUpdateView();
    //   setProgress(false);

    //   setToast({
    //     success: true,
    //     message: Constants.Actions.Created.Success("Media"),
    //   });
    // } catch (error) {
    //   console.log(error);
    //   setProgress(false);
    //   setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    // }

    return false;
  };

  const formSubmitHandler = async (values) => {
    const payload = {
      name: values.name,
      file: values.file,
    };

    if (values.type == "VIDEO") {
      const img = document.getElementById("thumbnail");

      payload.thumbnail = await fetch(img.src)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "thumbnail.png", blob);
          console.log(file);
          return file;
        });

      payload.duration = values.duration;
    }

    if (values.context) {
      payload.context = values.context;
    }

    console.log(payload);

    try {
      setStatus({
        loading: true,
        error: false,
      });
      const data = await createMedia(payload);
      setStatus({
        loading: false,
        error: false,
        success: true,
        message: "Media Uploaded Successfully",
      });
      onCreate(values);
      handleClose();
    } catch (error) {
      // error
      setStatus({
        loading: false,
        error: true,
        message: Utils.CustomErrorMessage(error),
      });
      onError(Utils.CustomErrorMessage(error));
    }
  };

  return (
    <Dialog
      open={open ? true : false}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      fullWidth
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>
            <h2 className="font-extrabold text-lg">Upload Media</h2>
          </Box>
          <Box>
            <IconButton onClick={handleClose}>
              <IoCloseOutline />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div className="flex flex-col gap-4">
          {formik.values.file ? (
            <>
              {formik.values.type == "IMAGE" && (
                <img src={formik.values.fileUri} className="object-cover" />
              )}

              {formik.values.type == "VIDEO" && (
                <>
                  <video controls className="object-cover">
                    <source src={formik.values.fileUri} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>

                  <div>
                    <img
                      src={formik.values.thumbnail}
                      id="thumbnail"
                      className="object-cover w-1/3 rounded-md"
                    />
                  </div>

                  <div className="text-sm text-gray-600">
                    {" "}
                    Duration : {formik.values.duration} mins
                  </div>
                </>
              )}

              {formik.values.type == "DOCUMENT" ||
                (formik.values.type == "FILE" && (
                  <DocViewer
                    config={{
                      header: {
                        disableHeader: false,
                        disableFileName: false,
                        retainURLParams: false,
                      },
                    }}
                    documents={[{ uri: formik.values.fileUri }]}
                    pluginRenderers={DocViewerRenderers}
                  />
                ))}

              <div>
                <h5 className="font-bold flex gap-1">
                  <div className="flex-grow">{formik.values.name}</div>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      formik.resetForm();
                    }}
                  >
                    Change
                  </Button>
                </h5>
                <div className="text-xsm font-bold text-gray-600">
                  {" "}
                  {formik.values.type}
                </div>
              </div>
            </>
          ) : (
            <>
              <Lottie
                animationData={uploadLottie}
                play
                loop={true}
                // style={{ width: 150, height: 150 }}
                className="m-auto"
              />

              <Button
                variant="contained"
                onClick={() => {
                  document.getElementById("fileInput").click();
                }}
              >
                Upload File
              </Button>
            </>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Back</Button>

        <Button
          color="success"
          onClick={formik.handleSubmit}
          type="submit"
          disabled={!formik.values.file}
        >
          Upload
        </Button>

        <div className="hidden">
          <input type="file" id="fileInput" onChange={handleUpload} />
        </div>
      </DialogActions>
      {status.loading ? (
        <Box>
          <LinearProgress />
        </Box>
      ) : (
        ""
      )}
    </Dialog>
  );
}

export default MediaUploadDialog;
